import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MenuItem, SortEvent } from 'primeng/api';
import { Utilityservice } from 'src/app/views/utility/utilityservice.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CurrencymodalComponent } from '../../directives/currencymodal/currencymodal.component';
import { CurrencyService } from './currency.service';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';
@Component({
  selector: 'app-category',
  templateUrl: './currency.component.html',
  styleUrls: ['./currency.component.css']
})

export class CurrencyComponent implements OnInit {
  @ViewChild('dt') dt: any;
  items: MenuItem[] | undefined;
  tablecount: number = 0;
  currencylistarray: Array<any> = [];
  exceldownloadModal = false;
  currencylist: any;
  ref: DynamicDialogRef | undefined;
  categoryScrollHeight = '';
  firstpage: number = 1;
  rows: number = 10;
  totalRecords: number = 0;
  options = [{ label: 10, value: 10 }];
  paginatorArray = [];
  position = 'top';
  excel_paragraph = '';
  downloadformate = false;
  templatedownloadtext = '';
  masteritems: MenuItem[] | undefined;
  userRole = "";
  createRight = "";
  searchTerm: string = ''; 
  customSort: boolean = true;

  constructor(
    public router: Router, public utilityserv: Utilityservice, public PagehelpmodalService: PagehelpmodalService,
    public dialogService: DialogService, private CurrencyService: CurrencyService, private spinner: NgxSpinnerService
  ) {
    this.excel_paragraph = this.CurrencyService.downloadexcel_text

  }
  ngOnInit() {
    this.categoryScrollHeight = this.utilityserv.scrollHeight
    this.getCurrencydata();
    this.getConfiguration();
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.categoryScrollHeight = this.utilityserv.updateScrollHeight();
  }


  dismiss() {
    Swal.fire({
      title: "Do you want to save the changes?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Save",
      denyButtonText: `Don't Save`
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Saved!", "", "success");
        this.ref.close();
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved!", "", "info");
        this.ref.close();
      }
    });
  }


  //    getCurrencydata() {
  //     this.spinner.show();
  //     this.CurrencyService.getCurrencyList().subscribe((data:any) => {
  //       this.spinner.hide();
  //     this.currencylistarray = data;
  //     this.options=  this.utilityserv.getOptionDropdown(data.length);
  //     this.paginatorArray=this.options.map(e=>e.value)
  //     this.currencylistarray.map(e=>{
  //      e['isSelect']=false
  //    })
  //    this.totalRecords=this.currencylistarray.length;
  //    this.tablecount = data.count;
  //  });
  // }

  currentPageIndex: number = 0;
  rowsize: number = 10;
  getCurrencydata() {

    this.spinner.show();
    const currentPageSize = this.rowsize;
    this.CurrencyService.getCurrencyList().subscribe({
      next: (data: any) => {
        this.spinner.hide();
        this.currencylistarray = data;
        this.currencylistarray = data.map(item => ({ ...item, isSelect: false }));
        this.options = this.utilityserv.getOptionDropdown(data.length);
        this.paginatorArray = this.options.map(e => e.value);

        if (!this.paginatorArray.includes(currentPageSize)) {
          this.paginatorArray.push(currentPageSize);
          this.paginatorArray.sort((a, b) => a - b);
        }

        this.rowsize = currentPageSize;
        this.totalRecords = this.currencylistarray.length;
        this.tablecount = data.count ?? data.length;
        setTimeout(() => {
          if (this.dt) {
            this.dt.first = this.currentPageIndex;
          }
        }, 0);
      },

      error: (error) => {
        this.spinner.hide();
        const timestamp = new Date().toLocaleString();
        Swal.fire({
          title: error.error?.error || "Error!",
          text: `This error occurred at: ${timestamp}`,
          icon: "error",
        });
      }
    });
  }


  show(title, data) {
    let details = {};
    this.currentPageIndex = this.dt?.first || 0;
    if (title === 'Modify currency') {
      this.CurrencyService.getcurrency(data.ct_currencyid).subscribe((res: any) => {
        if (res.length === 0) {
          Swal.fire({
            icon: 'error',
            title: 'Data Error',
            text: 'Data is null',
          });
        } else {
          details = res;
          this.ref = this.dialogService.open(CurrencymodalComponent, {
            header: title,
            width: '40vw',
            height: 'auto',
            data: { title: title, datas: details },
            contentStyle: { overflow: 'auto' },
            baseZIndex: 10000,
          });
          this.ref.onClose.subscribe(() => {
            this.getCurrencydata();
          });
        }
      })
    } else {
      details = {};
      this.ref = this.dialogService.open(CurrencymodalComponent, {
        header: title,
        width: '40vw',
        height: 'auto',
        data: { title: title, datas: details },
        contentStyle: { overflow: 'auto', },
        baseZIndex: 10000,
      });
      this.ref.onClose.subscribe(() => {
        this.getCurrencydata();
      });
    }
  }


  handlePageChange(event: any) {
    this.rowsize = event.rows;
    this.currentPageIndex = event.first;
  }
  excelData() {

    this.CurrencyService.currencyDataExcel().subscribe((response: Blob) => {
      const blob = new Blob([response],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Currency_Data.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      this.exceldownloadModal = false
      Swal.fire('File downloaded successfully!', '', 'success');

    }, error => {
      Swal.fire('Something went wrong', '', 'error');
    });
  }

  getConfiguration(): void {
    this.CurrencyService.getConfiguration().subscribe(
      (response) => {
        if (response && response.length > 0) {
          this.userRole = response[0]?.userRole ;
          this.createRight = response[0]?.createRight;
 
        }
      },
      (error) => {
        console.error('Error fetching configuration:', error);
      }
    );
  }
  cleanRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlight(input: string, searchstring: string | number): string {
    if (!searchstring) return input;
    const safeText = String(input ?? '');
    const safeSearch = this.cleanRegExp(String(searchstring));
    const re = new RegExp(safeSearch, 'gi');
    return safeText.replace(re, match => `<span class="highlightsearch">${match}</span>`);
  }

}
